import React, { lazy } from 'react';
import Login from './pages/other/Login';
import Products from './pages/other/products';
import Orders from './pages/other/Orders';
import CreateReturn from './pages/other/CreateReturn';
import ReturnDetails from './pages/other/ReturnDetails';

// Home pages (lazy-loaded)
const HomeFashion = lazy(() => import('./pages/home/HomeFashion'));
const HomeFashionTwo = lazy(() => import('./pages/home/HomeFashionTwo'));
const HomeFashionThree = lazy(() => import('./pages/home/HomeFashionThree'));
const HomeFashionFour = lazy(() => import('./pages/home/HomeFashionFour'));
const HomeFashionFive = lazy(() => import('./pages/home/HomeFashionFive'));
const HomeFashionSix = lazy(() => import('./pages/home/HomeFashionSix'));
const HomeFashionSeven = lazy(() => import('./pages/home/HomeFashionSeven'));
const HomeFashionEight = lazy(() => import('./pages/home/HomeFashionEight'));
const HomeKidsFashion = lazy(() => import('./pages/home/HomeKidsFashion'));
const HomeCosmetics = lazy(() => import('./pages/home/HomeCosmetics'));
const HomeFurniture = lazy(() => import('./pages/home/HomeFurniture'));
const HomeFurnitureTwo = lazy(() => import('./pages/home/HomeFurnitureTwo'));
const HomeFurnitureThree = lazy(() =>
  import('./pages/home/HomeFurnitureThree')
);
const HomeFurnitureFour = lazy(() => import('./pages/home/HomeFurnitureFour'));
const HomeFurnitureFive = lazy(() => import('./pages/home/HomeFurnitureFive'));
const HomeFurnitureSix = lazy(() => import('./pages/home/HomeFurnitureSix'));
const HomeFurnitureSeven = lazy(() =>
  import('./pages/home/HomeFurnitureSeven')
);
const HomeElectronics = lazy(() => import('./pages/home/HomeElectronics'));
const HomeElectronicsTwo = lazy(() =>
  import('./pages/home/HomeElectronicsTwo')
);
const HomeElectronicsThree = lazy(() =>
  import('./pages/home/HomeElectronicsThree')
);
const HomeBookStore = lazy(() => import('./pages/home/HomeBookStore'));
const HomeBookStoreTwo = lazy(() => import('./pages/home/HomeBookStoreTwo'));
const HomePlants = lazy(() => import('./pages/home/HomePlants'));
const HomeFlowerShop = lazy(() => import('./pages/home/HomeFlowerShop'));
const HomeFlowerShopTwo = lazy(() => import('./pages/home/HomeFlowerShopTwo'));
const HomeOrganicFood = lazy(() => import('./pages/home/HomeOrganicFood'));
const HomeOrganicFoodTwo = lazy(() =>
  import('./pages/home/HomeOrganicFoodTwo')
);
const HomeOnepageScroll = lazy(() => import('./pages/home/HomeOnepageScroll'));
const HomeGridBanner = lazy(() => import('./pages/home/HomeGridBanner'));
const HomeAutoParts = lazy(() => import('./pages/home/HomeAutoParts'));
const HomeCakeShop = lazy(() => import('./pages/home/HomeCakeShop'));
const HomeHandmade = lazy(() => import('./pages/home/HomeHandmade'));
const HomePetFood = lazy(() => import('./pages/home/HomePetFood'));
const HomeMedicalEquipment = lazy(() =>
  import('./pages/home/HomeMedicalEquipment')
);
const HomeChristmas = lazy(() => import('./pages/home/HomeChristmas'));
const HomeBlackFriday = lazy(() => import('./pages/home/HomeBlackFriday'));
const HomeBlackFridayTwo = lazy(() =>
  import('./pages/home/HomeBlackFridayTwo')
);
const HomeValentinesDay = lazy(() => import('./pages/home/HomeValentinesDay'));

// Shop pages (lazy-loaded)
const ShopGridStandard = lazy(() => import('./pages/shop/ShopGridStandard'));
const ShopGridFilter = lazy(() => import('./pages/shop/ShopGridFilter'));
const ShopGridTwoColumn = lazy(() => import('./pages/shop/ShopGridTwoColumn'));
const ShopGridNoSidebar = lazy(() => import('./pages/shop/ShopGridNoSidebar'));
const ShopGridFullWidth = lazy(() => import('./pages/shop/ShopGridFullWidth'));
const ShopGridRightSidebar = lazy(() =>
  import('./pages/shop/ShopGridRightSidebar')
);
const ShopListStandard = lazy(() => import('./pages/shop/ShopListStandard'));
const ShopListFullWidth = lazy(() => import('./pages/shop/ShopListFullWidth'));
const ShopListTwoColumn = lazy(() => import('./pages/shop/ShopListTwoColumn'));

// Product pages (lazy-loaded)
const Product = lazy(() => import('./pages/shop-product/Product'));
const ProductTabLeft = lazy(() =>
  import('./pages/shop-product/ProductTabLeft')
);
const ProductTabRight = lazy(() =>
  import('./pages/shop-product/ProductTabRight')
);
const ProductSticky = lazy(() => import('./pages/shop-product/ProductSticky'));
const ProductSlider = lazy(() => import('./pages/shop-product/ProductSlider'));
const ProductFixedImage = lazy(() =>
  import('./pages/shop-product/ProductFixedImage')
);

// Blog pages (lazy-loaded)
const BlogStandard = lazy(() => import('./pages/blog/BlogStandard'));
const BlogNoSidebar = lazy(() => import('./pages/blog/BlogNoSidebar'));
const BlogRightSidebar = lazy(() => import('./pages/blog/BlogRightSidebar'));
const BlogDetailsStandard = lazy(() =>
  import('./pages/blog/BlogDetailsStandard')
);

// Other pages (lazy-loaded)
const About = lazy(() => import('./pages/other/About'));
const Contact = lazy(() => import('./pages/other/Contact'));
const MyAccount = lazy(() => import('./pages/other/MyAccount'));
const LoginRegister = lazy(() => import('./pages/other/LoginRegister'));
const Cart = lazy(() => import('./pages/other/Cart'));
const Wishlist = lazy(() => import('./pages/other/Wishlist'));
const Compare = lazy(() => import('./pages/other/Compare'));
const Checkout = lazy(() => import('./pages/other/Checkout'));
const NotFound = lazy(() => import('./pages/other/NotFound'));
const Client = lazy(() => import('./pages/other/Client'));
const OrderDetails = lazy(() => import('./pages/other/OrderDetails'));
const Category = lazy(() => import('./pages/other/Category'));


const routes = [
  // Home pages
  {
    path: process.env.PUBLIC_URL + '/',
    element: <HomeFashionTwo />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-fashion',
    element: <HomeFashion />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-fashion-two',
    element: <HomeFashionTwo />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-fashion-three',
    element: <HomeFashionThree />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-fashion-four',
    element: <HomeFashionFour />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-fashion-five',
    element: <HomeFashionFive />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-fashion-six',
    element: <HomeFashionSix />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-fashion-seven',
    element: <HomeFashionSeven />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-fashion-eight',
    element: <HomeFashionEight />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-kids-fashion',
    element: <HomeKidsFashion />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-cosmetics',
    element: <HomeCosmetics />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-furniture',
    element: <HomeFurniture />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-furniture-two',
    element: <HomeFurnitureTwo />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-furniture-three',
    element: <HomeFurnitureThree />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-furniture-four',
    element: <HomeFurnitureFour />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-furniture-five',
    element: <HomeFurnitureFive />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-furniture-six',
    element: <HomeFurnitureSix />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-furniture-seven',
    element: <HomeFurnitureSeven />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-electronics',
    element: <HomeElectronics />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-electronics-two',
    element: <HomeElectronicsTwo />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-electronics-three',
    element: <HomeElectronicsThree />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-book-store',
    element: <HomeBookStore />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-book-store-two',
    element: <HomeBookStoreTwo />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-plants',
    element: <HomePlants />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-flower-shop',
    element: <HomeFlowerShop />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-flower-shop-two',
    element: <HomeFlowerShopTwo />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-organic-food',
    element: <HomeOrganicFood />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-organic-food-two',
    element: <HomeOrganicFoodTwo />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-onepage-scroll',
    element: <HomeOnepageScroll />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-grid-banner',
    element: <HomeGridBanner />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-auto-parts',
    element: <HomeAutoParts />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-cake-shop',
    element: <HomeCakeShop />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-handmade',
    element: <HomeHandmade />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-pet-food',
    element: <HomePetFood />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-medical-equipment',
    element: <HomeMedicalEquipment />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-christmas',
    element: <HomeChristmas />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-black-friday',
    element: <HomeBlackFriday />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-black-friday-two',
    element: <HomeBlackFridayTwo />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/home-valentines-day',
    element: <HomeValentinesDay />,
    protected: true,
  },

  // Shop pages
  {
    path: process.env.PUBLIC_URL + '/shop-grid-standard',
    element: <ShopGridStandard />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/shop-grid-filter',
    element: <ShopGridFilter />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/shop-grid-two-column',
    element: <ShopGridTwoColumn />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/shop-grid-no-sidebar',
    element: <ShopGridNoSidebar />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/shop-grid-full-width',
    element: <ShopGridFullWidth />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/shop-grid-right-sidebar',
    element: <ShopGridRightSidebar />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/shop-list-standard',
    element: <ShopListStandard />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/shop-list-full-width',
    element: <ShopListFullWidth />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/shop-list-two-column',
    element: <ShopListTwoColumn />,
    protected: true,
  },

  // Product pages
  {
    path: process.env.PUBLIC_URL + '/product/:id',
    element: <Product />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/product-tab-left/:id',
    element: <ProductTabLeft />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/product-tab-right/:id',
    element: <ProductTabRight />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/product-sticky/:id',
    element: <ProductSticky />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/product-slider/:id',
    element: <ProductSlider />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/product-fixed-image/:id',
    element: <ProductFixedImage />,
    protected: true,
  },

  // Blog pages
  {
    path: process.env.PUBLIC_URL + '/blog-standard',
    element: <BlogStandard />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/blog-no-sidebar',
    element: <BlogNoSidebar />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/blog-right-sidebar',
    element: <BlogRightSidebar />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/blog-details-standard',
    element: <BlogDetailsStandard />,
    protected: true,
  },

  // Other pages
  {
    path: process.env.PUBLIC_URL + '/about',
    element: <About />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/contact',
    element: <Contact />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/my-account',
    element: <MyAccount />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/login',
    element: <Login />,
    // element: <LoginRegister />,
    protected: false,
    redirectIfAuthenticated: true,
  },
  {
    path: process.env.PUBLIC_URL + '/cart',
    element: <Cart />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/wishlist',
    element: <Wishlist />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/compare',
    element: <Compare />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/checkout',
    element: <Checkout />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/clients',
    element: <Client />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/products',
    element: <Products />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders/:orderId',
    element: <OrderDetails />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders',
    element: <Orders />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders/:orderId/createReturn',
    element: <CreateReturn />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders/:orderId/:returnId',
    element: <ReturnDetails />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/categories',
    element: <Category />,
    protected: true,
  },

  // Fallback Route
  { path: '*', element: <NotFound />, protected: true },
];

export default routes;
